export const ActionTypes = {
  LOADING: "GET_CONS_LOADING",
  ERROR: "GET_CONS_ERROR",
  SUCCESS: "GET_CONS_SUCCESS",
};
